import React from 'react';
import './spinner.css'; // Import the CSS file

const Spinner = () => {
    return (
        <div className="spinner-container">
            <div className="spinner"></div>
        </div>
    );
};

export default Spinner;